import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PhysicianService } from '@core/service';
import { PhysicianAccountPgpsDTO } from '@mynexus/mynexus-ui-lib';
import { finalize } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-physician-search',
    templateUrl: './physician-search.component.html',
    styleUrls: ['./physician-search.component.scss'],
    standalone: false
})
export class PhysicianSearchComponent implements OnInit, OnDestroy {
  @Input() tenantId: string;
  @Input() physicianType: string;
  @Input() label = '';
  @Input() displayFollowingCheckbox = false;
  @Input() isDefaultViewMode = false;
  @Input() sameAsOrdering = false;
  @Input() npiNotFound = false;
  @Input() isPhysicianNotFoundView = false;

  @Output() physicianResultList = new EventEmitter<PhysicianAccountPgpsDTO[]>();
  @Output() sameAsOrderingChange = new EventEmitter<boolean>();
  @Output() npiNotFoundChange = new EventEmitter<boolean>();

  isLoading = false;
  searchText: string;
  searchForm: FormGroup;
  npiCheck = new FormControl();
  sameAsOrderingCheck = new FormControl();

  private subs = new SubSink();

  constructor(private physicianService: PhysicianService) {}

  ngOnInit() {
    this.buildPhysicianSearchForm();
    this.setCheckbox();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  buildPhysicianSearchForm() {
    this.searchForm = new FormGroup({
      searchText: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
      ]),
    });

    this.searchFormWatch();
    this.checkboxWatch();
  }

  searchFormWatch(): void {
    this.subs.sink = this.searchForm.valueChanges.subscribe((val) => {
      this.searchText = val.searchText;
    });
  }

  setCheckbox() {
    if (this.npiNotFound) {
      this.npiCheck.setValue(true);
    }

    if (this.sameAsOrdering) {
      this.sameAsOrderingCheck.setValue(true);
    }
  }

  checkboxWatch() {
    this.subs.sink = this.npiCheck.valueChanges.subscribe((res) =>
      this.npiNotFoundChange.emit(res)
    );

    this.subs.sink = this.sameAsOrderingCheck.valueChanges.subscribe((res) =>{
      this.npiCheck.setValue(false);
      this.sameAsOrderingChange.emit(res)
    });
  }

  searchNPI() {
    this.isLoading = true;

    this.physicianService
      .getActivePhysicianAccountPgpsByNpi(this.searchText, this.tenantId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((physicianList) => {
        this.sameAsOrderingCheck.reset();
        this.physicianResultList.emit(physicianList);
        this.isPhysicianNotFoundView = !physicianList?.length;
      });
  }
}
